export default {
    jobs: [],
    jobsLoading: false,
    jobPrintColors: [],
    orderComponents: [],
    productTypeConfigurations: [],
    orderComponentsLoading: false,
    machines: [],
    machinesLoading: false,
    dieCutters: [],
    dieCuttersLoading: false,
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        search: null,
        status_ids: true,
    }
}
